import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container pt-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { key: 0 }

import {IBottomSheet} from "@/interfaces/components/general/IBottomSheet";
import {computed, ref, watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  props: {
    bottomSheet: {}
  },
  setup(__props: any) {

const isModal = ref(false)
const props = __props

const computedBottomSheet = computed(() => props.bottomSheet);

watch(computedBottomSheet, (value) => {
  isModal.value = value.show
}, {deep: true})


return (_ctx: any,_cache: any) => {
  const _component_swipe_modal = _resolveComponent("swipe-modal")!

  return (computedBottomSheet.value)
    ? (_openBlock(), _createBlock(_component_swipe_modal, {
        key: 0,
        modelValue: isModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModal).value = $event)),
        "contents-height": "70vh",
        "border-top-radius": "16px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (computedBottomSheet.value.title)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(computedBottomSheet.value.title), 1))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1))
            ]),
            (computedBottomSheet.value.content)
              ? (_openBlock(), _createBlock(_KeepAlive, { key: 0 }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(computedBottomSheet.value.content.render), _mergeProps({
                    class: computedBottomSheet.value.content.customClass ?? ''
                  }, _toHandlers(computedBottomSheet.value.content.events ?? []), computedBottomSheet.value.content.content ?? {}), null, 16, ["class"]))
                ], 1024))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})